export class Language {
  languageCode: string;
  displayNameEn: string;
  displayNameMx: string;
  displayNameHu: string;
  displayNameCn: string;
  displayNameDa: string;
  displayNameCs: string;
}
